import type { CSSProperties } from 'react';
import { DEFAULT_AVATAR_COLOR, pseudoInitials } from '../../systems/player-profile';
import styles from './player-avatar.module.css';

interface PlayerAvatarProps {
  pseudo: string;
  color?: string | null;
  /** Diamètre en px. Sans valeur, la taille vient de `--avatar-size` posée par le parent. */
  size?: number;
  className?: string;
}

/**
 * L'avatar du joueur : les initiales du pseudo dans un anneau de la couleur choisie.
 * Décoratif : le pseudo est toujours écrit à côté.
 */
export function PlayerAvatar({ pseudo, color, size, className }: PlayerAvatarProps) {
  const style = {
    '--c': color || DEFAULT_AVATAR_COLOR,
    ...(size ? { '--t': `${size}px` } : {}),
  } as CSSProperties;

  return (
    <span className={`${styles.avatar}${className ? ` ${className}` : ''}`} style={style} aria-hidden="true">
      <span className={styles.initials}>{pseudoInitials(pseudo)}</span>
    </span>
  );
}
